import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Inter is served from our own origin. It used to be an @import from Google Fonts at the top of
// index.css, which blocks rendering: whenever fonts.googleapis.com stalled (it does, from Russian
// networks) the whole site stayed blank although our server had answered. Only the weights the
// CSS uses; each file carries a unicode-range, so a browser downloads just Cyrillic and Latin.
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/inter/800.css'
import './index.css'
import './styles/manager-theme.css'
import App from './App.tsx'
import { registerSW } from 'virtual:pwa-register'
import { startPwaInstallCapture } from './lib/pwaInstall'
import { startPwaUpdates } from './lib/pwaUpdate'

// The browser's «can be installed» event fires once, early, on whatever page is open — keep it
// for the «Приложение Лупа» card in the profile (lib/pwaInstall.ts).
startPwaInstallCapture()
// Registers the service worker and keeps an open or long-lived installed app on the newest release.
startPwaUpdates(registerSW)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
